import React from 'react';
import { Model } from "@singularsystems/neo-core";
import { NeoGrid } from "@singularsystems/neo-react";
import { Catalogue } from "@singularsystems/neo-react-services";
import { CatalogueEntry } from "../CatologueEntry";
import * as Roles from "../../../AccessControl/Models/Commands/Security/Roles";
import DataCache from "../../StaticData/StaticDataCache";
import { IGeneralApiClient } from "../../../Common/ApiClients/GeneralApiClient";
import CorporateActionStageLookup from '../../../Common/Models/CorporateActionStageLookup';

export default class CorporateActionStageCatalogueEntry extends CatalogueEntry<CorporateActionStageLookup> {
    
    constructor() {
        super("Corporate Action Stage", CorporateActionStageLookup);
    }

    public get editRole() {
        return Roles.CatalogueRoles.Edit;
    }

    public getCacheEntry(cache: DataCache) {
        return cache.corporateActionStages
    }

    public getSaveEndpoint(apiClient: IGeneralApiClient) {
        return apiClient.saveCorporateActionStageList;
    }

    public renderRow(item: CorporateActionStageLookup, meta: Model.TransformMetaType<CorporateActionStageLookup>) {
        return (
            <NeoGrid.Row>
                <NeoGrid.Column bind={meta.stageName} />
                <Catalogue.ButtonColumn />
            </NeoGrid.Row>
        );
    }
}